export default __webpack_public_path__ + "static/media/whatsapp_mobile_blank.37bce83e.png";